angular.module('impactx.rfx').controller('TimedBaseProductStockDialogCtrl', [
    '$scope',
    'TranslationService',
    '$mdDialog',
    'dataGen',
    'product',
    TimedBaseProductStockDialogCtrl
]);

function TimedBaseProductStockDialogCtrl($scope, TranslationService, $mdDialog, dataGen, product) {
    var self = this;

    dataGen.getData($scope, {proId: product.id}, "/product/timedbaseproductstock").then(function () {
        $scope.trns.ok = TranslationService.get("ok");
    });

    self.abort = function () {
        $mdDialog.cancel();
    };
}